import { useNavigate } from "react-router-dom";
import "./App.css";
import AppRouter from "./routes/AppRouter";
import { useEffect, useState } from "react";
import { getDomainName } from "./config/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import { setBannerImage, setDomainName } from "./redux/domainSlice";
import { de } from "date-fns/locale";
import { fetchContentConfig } from "./redux/contentConfigurationSlice";


function App() { 
  const location = window.location;
  const dispatch = useDispatch();

  const { data } = useSelector((state) => state.contentConfig);

  useEffect(() => {
    // ✅ fetch only if not already loaded (prevents multiple calls)
    if (!data) {
      dispatch(fetchContentConfig());
    }
  }, [data, dispatch]);

  // if (location.hostname !== "localhost") {
  //   console.log = () => {};
  //   console.info = () => {};
  //   console.error = () => {};
  //   console.warn = () => {};
  //   console.assert = () => {};
  //   console.table = () => {};
  //   console.debug = () => {};
  // }
  const blueCollarImg = "/images/blueCollar.png";
  const hospitalityImg = "/images/hospitality.png";
  const aiJobsImg = "/images/aiJobs.png";
  const whiteCollarImg = "/images/whiteCollar.png";
  const itJobsImg = "/images/itjobs.png";
  const salesJobsImg = "/images/salesJobs.png";
  const internshipImg = "/images/internship.png";
  const automotiveImg = "/images/auto.png";
  const fresherJobs = "/images/fresherJobs.png";
  const ayurvedaImg = "/images/ayurveda.png";

  const [routes, setRoutes] = useState([]);
  const port = window.location.port;

  // useEffect(() => {
  //   const loadRoutes = async () => {
  //     if (port === "3000") {
  //       const blueCollarRoutes = (await import("./routes/blueCollarRoutes")).default;
  //       setRoutes(blueCollarRoutes);
  //     } else if (port === "3001") {
  //       const whiteCollarRoutes = (await import("./routes/whiteCollarRoutes")).default;
  //       setRoutes(whiteCollarRoutes);
  //     }
  //   };
  //   loadRoutes();
  // }, [port]);

  const DomainName = location.hostname;

  useEffect(() => {

    const setDomain = async () => {
      // Determine the environment
      const environment = DomainName.includes("dev.") || DomainName.includes("dev")
        ? "dev"
        : DomainName.includes("stg.")
          ? "stg"
          : DomainName === "localhost"
            ? "localhost"
            : "prod"; // Default to "prod" if no .dev., .stg., or localhost is present

      // Determine the subdomain
      let subdomain = "";
      if (DomainName.includes("itjobs") || port === "3005") {
        subdomain = "itjobs";
        dispatch(setBannerImage(itJobsImg));
      }
      else if (
        DomainName.includes("bluecollar") ||
        (environment === "localhost" && port === "3004")
      ) {
        subdomain = "bluecollar";
        dispatch(setBannerImage(blueCollarImg));
      } else if (
        DomainName.includes("whitecollar") ||
        (environment === "localhost" && port === "3003")
      ) {
        subdomain = "whitecollar";
        dispatch(setBannerImage(whiteCollarImg));
      } else if (
        DomainName.includes("hospitality") ||
        (environment === "localhost" && port === "3002")
      ) {
        subdomain = "hospitality";
        dispatch(setBannerImage(hospitalityImg));
      } else if (
        DomainName.includes("aijobs") ||
        (environment === "localhost" && port === "3001")
      ) {
        subdomain = "aijobs";
        dispatch(setBannerImage(aiJobsImg));
      }
      else if (
        DomainName.includes("sales") ||
        (environment === "localhost" && port === "3000")
      ) {
        subdomain = "sales";
        dispatch(setBannerImage(salesJobsImg));
      } else if (
        DomainName.includes("internship") ||
        (environment === "localhost" && port === "3006")
      ) {
        subdomain = "internship";
        dispatch(setBannerImage(internshipImg));
      } else if (
        DomainName.includes("automotive") ||
        (environment === "localhost" && port === "3007")
      ) {
        subdomain = "automotive";
        dispatch(setBannerImage(automotiveImg));
      } else if (
        DomainName.includes("fresherjobs") ||
        (environment === "localhost" && port === "3008")
      ) {
        subdomain = "fresherjobs";
        dispatch(setBannerImage(fresherJobs));
      } else if (
        DomainName.includes("ayurveda") ||
        (environment === "localhost" && port === "3009")
      ) {
        subdomain = "ayurveda";
        dispatch(setBannerImage(ayurvedaImg));
      }
      else {
        subdomain = "sbj";
      }

      // Handle routes and dispatch based on environment and subdomain
      switch (subdomain) {
        case "bluecollar":
          switch (environment) {
            case "dev":
            case "localhost":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/blueCollarRoutes")).default);
              break;
            case "stg":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/blueCollarRoutes")).default);
              break;
            case "prod":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/blueCollarRoutes")).default);
              break;
            default:
              console.warn("Environment not recognized for bluecollar.");
          }
          break;

        case "whitecollar":
          switch (environment) {
            case "dev":
            case "localhost":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/whiteCollarRoutes")).default);
              break;
            case "stg":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/whiteCollarRoutes")).default);
              break;
            case "prod":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/whiteCollarRoutes")).default);
              break;
            default:
              console.warn("Environment not recognized for whitecollar.");
          }
          break;

        case "hospitality":
          switch (environment) {
            case "dev":
            case "localhost":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/hospitalityRoutes")).default);
              break;
            case "stg":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/hospitalityRoutes")).default);
              break;
            case "prod":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/hospitalityRoutes")).default);
              break;
            default:
              console.warn("Environment not recognized for hospitality.");
          }
          break;

        case "aijobs":
          switch (environment) {
            case "dev":
            case "localhost":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/aijobsRoutes")).default);
              break;
            case "stg":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/aijobsRoutes")).default);
              break;
            case "prod":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/aijobsRoutes")).default);
              break;
            default:
              console.warn("Environment not recognized for aijobs.");
          }
          break;

        case "sales":
          switch (environment) {
            case "dev":
            case "localhost":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/itJobsRoutes")).default);
              break;
            case "stg":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/itJobsRoutes")).default);
              break;
            case "prod":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/itJobsRoutes")).default);
              break;
            default:
              console.warn("Environment not recognized for aijobs.");
          }
          break;
        case "itjobs":
          switch (environment) {
            case "dev":
            case "localhost":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/itJobsRoutes")).default);
              break;
            case "stg":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/itJobsRoutes")).default);
              break;
            case "prod":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/itJobsRoutes")).default);
              break;
            default:
              console.warn("Environment not recognized for aijobs.");
          }
          break;
        case "internship":
          switch (environment) {
            case "dev":
            case "localhost":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/internshipRoutes")).default);
              break;
            case "stg":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/internshipRoutes")).default);
              break;
            case "prod":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/internshipRoutes")).default);
              break;
            default:
              console.warn("Environment not recognized for internship.");
          }
          break;
        case "automotive":
          switch (environment) {
            case "dev":
            case "localhost":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/automotiveRoutes")).default);
              break;
            case "stg":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/automotiveRoutes")).default);
              break;
            case "prod":
              dispatch(setDomainName(subdomain));
              setRoutes((await import("./routes/automotiveRoutes")).default);
              break;
            default:
              console.warn("Environment not recognized for automotive.");
          }
          break;
        case "fresherjobs":
          dispatch(setDomainName(subdomain));
          setRoutes((await import("./routes/fresherjobsRoutes")).default);
          break;
        case "ayurveda":
          dispatch(setDomainName(subdomain));
          setRoutes((await import("./routes/ayurvedaRoutes")).default);
          break;
        // https://dev.skillsbasedjobs.global/
        default:
          dispatch(setDomainName(subdomain));
          setRoutes((await import("./routes/HomeRoutes")).default);
          break;


      }
    };

    setDomain();
  }, [DomainName, dispatch]);

  return routes.length > 0 ? (
    <AppRouter routes={routes} />
  ) : (
    <div>Loading...</div>
  );

  return <AppRouter />;
}

export default App;